import type { NetworkType } from "./network-types.js";
import { LogType } from "./sacrifice-signers.js";

export type NetworkIdentifier = {
  chainId: number;
  networkType: NetworkType;
}

export type SerializedNetworkIdentifier = `${NetworkType}:${number}`

export type SerializedScopedNetworkIdentifier = `${SerializedNetworkIdentifier}:${string}`

export type BlockIdentifier = NetworkIdentifier & {
  blockHash: string;
}

export type TransactionIdentifier = NetworkIdentifier & {
  transactionHash: string;
}

export type ProjectIdentifier = {
  projectId: string;
}

export type ProjectNetworkIdentifier = NetworkIdentifier & ProjectIdentifier

export type TokenIdentifier = NetworkIdentifier & {
  tokenAddress: string;
}

export type BlockTokenIdentifier = TokenIdentifier & BlockIdentifier

export type SacrificeIdentifier = BlockTokenIdentifier & TransactionIdentifier & ProjectIdentifier & {
  logIndex: number;
  logType: LogType;
}

export type SerializedSacrificeIdentifier = `${SerializedScopedNetworkIdentifier}:${string}:${string}:${number}:${LogType}`

export function sacrifice(sacrifice: SacrificeIdentifier) {
  return [
    sacrifice.networkType,
    sacrifice.chainId,
    sacrifice.blockHash,
    sacrifice.transactionHash,
    sacrifice.tokenAddress,
    sacrifice.logIndex,
    sacrifice.logType,
  ].join(':') as SerializedSacrificeIdentifier
}

export function network(network: NetworkIdentifier) {
  return [
    network.networkType,
    network.chainId,
  ].join(':') as SerializedNetworkIdentifier
}

export function transaction(transaction: TransactionIdentifier) {
  return [
    transaction.networkType,
    transaction.chainId,
    transaction.transactionHash,
  ].join(':') as SerializedScopedNetworkIdentifier
}

export function block(block: BlockIdentifier) {
  return [
    block.networkType,
    block.chainId,
    block.blockHash,
  ].join(':') as SerializedScopedNetworkIdentifier
}

export function token(token: TokenIdentifier) {
  return [
    token.networkType,
    token.chainId,
    token.tokenAddress,
  ].join(':') as SerializedScopedNetworkIdentifier
}
